import { useState, useEffect } from 'react';
import { Divider } from '@mui/material';
import styles from './index.module.scss';
import { Header } from './Header';
import classNames from 'classnames';
import { QRCodeContent } from './QRCodeContent';
import { SMSContent } from './SMSContent';
import { InvitationCodeContent } from './InvitationCodeContent';
import { observer } from 'mobx-react-lite';
import useInviteSmsService from '../../../../../../../services/intakeDataService/inviteSmsService';
import { componentType } from '../../../../../../../hooks/useMixpanel';
import { useOnBoardingDrawer } from '../../../OnBoardingDrawerProvider';
import { capitalize } from 'lodash';

function PhoneNumberForm({
  patientUuid,
  mixpanelComponent,
}: {
  patientUuid?: string;
  mixpanelComponent?: componentType;
}) {
  const { getInviteQR } = useInviteSmsService();

  const [qrCode, setQrCode] = useState<string>('');
  const [inviteCode, setInviteCode] = useState<string>('');

  const {
    contextData: { patient },
  } = useOnBoardingDrawer();

  useEffect(() => {
    const load = async () => {
      if (!qrCode && patientUuid) {
        const result = await getInviteQR(patientUuid);
        setQrCode(result?.qrBase64Png ?? '');
        setInviteCode(result?.deepLinkSub1 ?? '');
      }
    };
    load();
  }, [patientUuid]);

  return (
    <div className={classNames(styles.root, 'flex flex-col gap-8')}>
      <Header firstName={patient?.firstName ? capitalize(patient?.firstName) : 'your patient'} />
      <SMSContent patientUuid={patientUuid} mixpanelComponent={mixpanelComponent} />
      <Divider>Or</Divider>
      <QRCodeContent qrBase64Code={qrCode} />
      <Divider>Or</Divider>
      <InvitationCodeContent inviteCode={inviteCode} />
    </div>
  );
}

export default observer(PhoneNumberForm);
